import { api } from "../client";
import { endpoints } from "../endpoints";

export const smsService = {
  /** @returns {Promise<import("../generated/migration").components["schemas"]["Recipients"]>} */
  async recipients(kind, id, signal) {
    return (await api.request({ url: kind === "exam" ? endpoints.sms.examRecipients(id) : endpoints.sms.assignmentRecipients(id),
      safeRead: true, signal })).data;
  },
  async send(kind, id, recipients, signal) {
    return (await api.request({ url: kind === "exam" ? endpoints.sms.sendExam(id) : endpoints.sms.sendAssignment(id),
      method: "POST", data: { recipients }, signal })).data;
  },
  async custom(data, signal) {
    return (await api.request({ url: endpoints.sms.custom, method: "POST", data, signal })).data;
  },
};
export function effectiveTarget(recipient, target) {
  if (target === "both" && recipient.has_mother && recipient.has_father) return "both";
  if (target === "father" && recipient.has_father) return "father";
  if (recipient.has_mother) return "mother";
  if (recipient.has_father) return "father";
  return null;
}
